import { objectType } from '../_util/type';
export default () => ({
    trigger: [String, Array],
    open: { type: Boolean, default: undefined },
    /** @deprecated Please use `open` instead. */
    visible: { type: Boolean, default: undefined },
    placement: String,
    color: String,
    transitionName: String,
    /** @deprecated Please use `styles.root` instead. */
    overlayStyle: objectType(),
    /** @deprecated Please use `styles.body` instead. */
    overlayInnerStyle: objectType(),
    /** @deprecated Please use `classNames.root` instead. */
    overlayClassName: String,
    openClassName: String,
    /** Semantic structure className (antd ≥ 5.23). */
    classNames: objectType(),
    /** Semantic structure style (antd ≥ 5.23). */
    styles: objectType(),
    prefixCls: String,
    mouseEnterDelay: Number,
    mouseLeaveDelay: Number,
    getPopupContainer: Function,
    /**@deprecated Please use `arrow={{ pointAtCenter: true }}` instead. */
    arrowPointAtCenter: { type: Boolean, default: undefined },
    arrow: {
        type: [Boolean, Object],
        default: true,
    },
    autoAdjustOverflow: {
        type: [Boolean, Object],
        default: undefined,
    },
    /** @deprecated Please use `destroyOnHidden` instead (antd ≥ 5.25). */
    destroyTooltipOnHide: { type: Boolean, default: undefined },
    /** Destroy overlay DOM when hidden (antd ≥ 5.25). */
    destroyOnHidden: { type: Boolean, default: undefined },
    align: objectType(),
    builtinPlacements: objectType(),
    children: Array,
    /** @deprecated Please use `onOpenChange` instead. */
    onVisibleChange: Function,
    /** @deprecated Please use `onUpdate:open` instead. */
    'onUpdate:visible': Function,
    onOpenChange: Function,
    'onUpdate:open': Function,
});
